import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class DeleteGroupErrorAction implements Action {
  public static readonly type = 'DeleteGroupErrorAction';

  constructor(public error: BijbError) {
  }

  public type = DeleteGroupErrorAction.type;
}
